import Validate from './Validate.js';


class Form {
    constructor(form) {
        this.$form = $(form);
        this.$btn = this.$form.find('.js-submit');
        this.recaptcha;
        this.messages = window.formMessages || {
            success: {
                'title': 'Успешно',
                'text': 'Ваша заявка успешно отправлена!'
            },
            error: {
                'title': 'Ошибка',
                'text': 'Пожалуйста, попробуйте позже'
            }
        };

        this.iti();
        this.validate();
        this.bindSubmit();
        this.bindClose();
        this.disableAutoFill();
        this.disableIEautocomplete();
        this.fileUpload();
        // this.filterPhone();
    }



    // Валидация
    validate() {
        new Validate(this.$form);
    }



    // Событие отправки
    bindSubmit() {
        const key = this.$form.data('recaptcha-key');
        const $input = this.$form.find('.js-recaptcha-input');
        $input.val('');

        this.$form.on('submit', (e) => {
            e.preventDefault();

            // Блокируем кнопку сабмита
            this.$btn.attr('disabled', true);

            // Запускаем проверку рекапчи
            try {
                grecaptcha
                    .execute(key, { action: 'ajax_submit' })
                    .then(token => {
                        $input.val(token);
                        this.sendForm();
                    });
            } catch (error) {
                // Ошибка на стороне рекапчи
                this.$form
                    .removeClass('_is-success')
                    .addClass('_is-error');

                console.error('recaptcha error');
            }
        });
    }



    // Отправка
    sendForm() {
        this.$form.ajaxSubmit({
            url: this.$form.attr('action'),
            dataType: 'json',
            // data: this.$form.serialize(),
            type: this.$form.attr('method') || 'GET',
            cache: false,
            success: (response) => {

                if (!response.success) {
                    // Ошибка на сервере
                    this.renderMessage('error', response);

                    this.$form
                        .removeClass('_is-success')
                        .addClass('_is-error');

                    // Разблокируем кнопку
                    this.$btn.removeAttr('disabled');

                } else {
                    // Успех!
                    this.resetForm();

                    this.renderMessage('success', response);

                    this.$form
                        .removeClass('_is-error')
                        .addClass('_is-success');
                }
            },
            error: () => {
                // Ошибка отправки
                this.renderMessage('error');

                this.$form
                    .removeClass('_is-success')
                    .addClass('_is-error');

                console.log('Ошибка отправки формы');

                // Разблокируем кнопку
                this.$btn.removeAttr('disabled');

                // Автоматически закрываем сообщения
                // setTimeout(() => {
                // this.$form.removeClass('_success _error');
                // }, 5000);
            }
        });
    }



    renderMessage(result, response = {}) {
        let title, text;

        /**
         * Подставляем тексты из ответа сервера, если есть.
         * Иначе — тексты по умолчанию.
         */
        if (result === 'success') {
            title = response.title || this.messages.success.title;
            text = response.message || this.messages.success.text;
        } else {
            title = response.title || this.messages.error.title;
            text = response.message || this.messages.error.text;
        }


        this.$form.find('.js-form-message-title').html(title);
        this.$form.find('.js-form-message-text').html(text);
    }



    // Закрытие формы
    bindClose() {
        App.H
            .find('.js-form-ok')
            .on('click', (e) => {
                e.preventDefault();
                this.$form.removeClass('_is-success _is-error');
            });
    }



    // Загрузка файла
    fileUpload() {
        this.$form
            .find('.js-upload')
            .on('change', function () {
                const $input = $(this);
                const $parent = $input.closest('.js-input-wrap');
                const $label = $parent.find('.js-upload-label');
                const $sizeText = $parent.find('.js-upload-filesize');
                const $formatText = $parent.find('.js-upload-format');
                const val = $input.val();
                let fileName;
                let filesize;

                if (val.length) {

                    // Имя файла
                    fileName = val.split('\\').pop() || '';
                    $label.text(fileName);
                    $input.addClass('_active');
                    $parent.addClass('_active');


                    // Размер файла
                    filesize = $input[0].files[0].size;

                    // Подпись к размеру Мб/Кб на языках rus/eng
                    const sign = App.H.attr('lang') === 'ru' ? [' Мб', ' Кб'] : [' Mb', ' Kb'];

                    if (filesize > 1048576) {
                        // Мб
                        filesize = (filesize / 1024 / 1024).toFixed(1) + sign[0];
                    } else {
                        // Кб
                        filesize = Math.ceil(filesize / 1024) + sign[1];
                    }

                    $sizeText.text(filesize);


                    // Расширение файла
                    const fileExt = fileName.split('.').pop();
                    $formatText.text(fileExt);

                    // $parent.find('.form__file-preview').attr('data-ext', fileExt);
                } else {
                    $input.removeClass('_active');
                    $label.text('');
                    $sizeText.text('');
                    $formatText.text('');
                    // $parent.removeClass('_active');
                }
            });


        this.$form
            .find('.js-upload-clear')
            .on('click', function () {
                $(this).siblings('.js-upload').val('').change();
            });
    }



    // Для поля телефона допускаем только цифры, пробел и +-()
    filterPhone() {
        this.$form.find('[data-phone]').on('input', function () {
            const val = $(this).val().replace(/[^0-9\s()+-]/g, '');
            $(this).val(val);
        });
    }



    // Сброс формы
    resetForm() {
        this.$form[0].reset();

        this.$form
            .find('.js-upload')
            .val('')
            .change()
            .closest('.js-input-wrap')
            .removeClass('_active');

        // this.$form.removeClass('_success _error');

        this.$form
            .find('[data-required]')
            .not(':checkbox')
            .addClass('_notvalidated')
            .removeClass('_error');

        this.$form
            .find(':checkbox[data-required]')
            .not(':checked')
            .addClass('_notvalidated');

        this.$form
            .find('.js-submit')
            .attr('disabled', true);

        this.$form
            .find('.js-input-wrap')
            .removeClass('_focused');

        this.$form
            .find('.js-dropdown')
            .trigger('dropdown:reset');
    }



    // Отключаем автозаполнение полей в хроме
    disableAutoFill() {
        this.$form
            .find('[type="text"], [type="email"], [type="tel"], [type="password"]')
            .attr('autocomplete', 'new-password');
    }



    // Фикс autocomplete="off" для IE и Edge
    disableIEautocomplete() {
        if (App.ie || App.edge) {
            window.onbeforeunload = function () {
                $('form[autocomplete="off"]').each(function () {
                    this.reset();
                });
            };
        }
    }



    // Маски и список стран для телефонов
    iti() {
        this.$form[0].querySelectorAll('.js-iti').forEach(input => {
            const countries = input.getAttribute('data-countries') ? input.getAttribute('data-countries').split(',') : null;
            const preferredCountries = input.getAttribute('data-preferred-countries') ? input.getAttribute('data-preferred-countries').split(',') : null;
            const defCountry = input.getAttribute('data-default-country');
            input.value = '';

            const iti = intlTelInput(input, {
                onlyCountries: countries ? countries : [],
                preferredCountries: preferredCountries ? preferredCountries : [],
                initialCountry: defCountry,
                nationalMode: false,
                autoPlaceholder: 'aggressive'
            });

            iti.promise.then(function () {
                setMask();
                input.addEventListener('countrychange', () => setMask());
            });

            function setMask() {
                let dialCode = iti.getSelectedCountryData().dialCode;
                let placeholder = input.getAttribute('placeholder');

                placeholder = placeholder
                    .replace(dialCode, '&')
                    .replace(/[0-9]/g, '9')
                    .replace('&', dialCode.replace(/9/g, '\\9'));

                input.value = '';

                $(input).inputmask('placeholder', {
                    showMaskOnHover: false,
                    mask: placeholder,
                    placeholder: '_'
                });
            }
        });
    }
}



grecaptcha.ready(() => {
    document.querySelectorAll('.js-form').forEach(el => {
        new Form(el);
    });
});



// WEBPACK FOOTER //
// ./_src/js/Form.js